<template>
  <div class="loading">
    <img src="@/assets/img/loading.svg" />
  </div>
</template>

<script>
export default {
  name: "admin-login",
  data() {
    return {};
  },
  methods: {
    async login(ticket) {
      let data = {
        ticket: ticket,
      };

      await this.$store.dispatch("authRequestWhitUser", data);
    },
    
    removeAllCookies() {
      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
    }
  },
  async created() {
    this.removeAllCookies();
    localStorage.clear();
    sessionStorage.clear();

    // Limpar Vuex state local sem chamar o backend (sem deletar sub_users)
    // O ERP já recriou o vínculo via POST /api/erp/admin/subuser antes de abrir esta URL
    this.$store.commit('resetPanel');
    this.$store.commit('authSuccess', '');

    // A URL carrega um ticket opaco de uso único, não mais base64(user_id).
    // Como o ticket expira em 60s e só vale uma vez, recarregar esta página
    // sempre falha — sem o catch o usuário ficaria preso no loading.
    try {
      await this.login(this.$route.params.ticket);
    } catch (error) {
      console.error("Falha ao autenticar com o ticket de acesso:", error);
      this.$router.replace({ name: "Login" });
    }
  },
};
</script>

<style lang="scss">
.loading {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9;

  img {
    width: 100px;
  }
}
</style>
